import {inside} from './ui.js';
export class Controls {
  constructor(game){this.game=game;this.pointers=new Map();this.keyClutch=false;this.drag=null;}
  clear(){this.pointers.clear();this.keyClutch=false;this.drag=null;this.game.race.vehicle.clutch=1;}
  isClutchDown(){return this.keyClutch||[...this.pointers.values()].some(p=>p.kind==='clutch');}
  pedalRect(){const {controlsTop,controlsBottom}=this.game.ui.layout;return {x:65,y:controlsTop+39,w:62,h:Math.min(148,controlsBottom-controlsTop-56)};}
  clutchRect(){return this.pedalRect();}
  gearPosition(gear=this.game.race.vehicle.gear){const {x,y,dx,dy}=this.game.ui.layout.gate;return gear?{x:x+(Math.floor((gear-1)/2)-1)*dx,y:y+(gear%2?-dy:dy)}:{x,y};}
  stickPosition(){return this.drag?.position||this.gearPosition();}
  isPlaying(){const r=this.game.race;return r.phase==='racing'&&!r.paused&&r.launched;}
  isInteractive(){return !this.game.race.paused&&['ready','countdown','racing'].includes(this.game.race.phase);}
  shift(gear){this.game.race.shift(gear);}
  handle(event){
    const g=this.game,r=g.race;
    if(event.type==='keyDown'){
      g.unlock();if(!this.isInteractive())return;
      if(event.key==='clutch')this.keyClutch=true;
      else if(event.key==='n')this.shift(0);
      else if(/^[1-6]$/.test(event.key))this.shift(Number(event.key));
      this.syncClutch();return;
    }
    if(event.type==='keyUp'){if(event.key==='clutch')this.keyClutch=false;this.syncClutch();return;}
    const p={x:event.x/g.ui.layout.scale,y:event.y/g.ui.layout.scale};
    if(event.type==='down'){
      g.unlock();const button=[...g.ui.buttons].reverse().find(b=>inside(p,b));
      if(button){this.pointers.set(event.id,{kind:'button',button});return;}
      if(!this.isInteractive())return;
      if(inside(p,this.clutchRect())){this.pointers.set(event.id,{kind:'clutch'});this.syncClutch();return;}
      const pos=this.gearPosition();
      if(this.isPlaying()&&!this.drag&&Math.hypot(pos.x-p.x,pos.y-p.y)<37){this.drag={id:event.id,position:pos,column:r.vehicle.gear?Math.floor((r.vehicle.gear-1)/2)-1:0,neutral:!r.vehicle.gear};this.pointers.set(event.id,{kind:'stick'});}
    }else if(event.type==='move'){
      if(this.drag?.id===event.id&&this.isPlaying())this.moveStick(p);
    }else if(event.type==='up'||event.type==='cancel'){
      const captured=this.pointers.get(event.id);this.pointers.delete(event.id);
      if(this.drag?.id===event.id)this.drag=null;
      if(event.type==='cancel'&&captured?.kind==='clutch'&&!this.isClutchDown()){r.pause();this.clear();}else this.syncClutch();
      if(captured?.kind==='button'&&event.type==='up'&&inside(p,captured.button))g.action(captured.button.id);
    }
  }
  syncClutch(){const r=this.game.race;if(this.isInteractive()){r.clutch(this.isClutchDown()?1:0);}}
  moveStick(p){
    const g=this.game,r=g.race,d=this.drag,{x,y,dx,dy}=g.ui.layout.gate;
    if(r.vehicle.clutch<.95){this.shift(0);this.drag=null;return;}
    if(!d.neutral){
      const sign=r.vehicle.gear%2?-1:1;
      d.position={x:x+d.column*dx,y:Math.max(y-dy,Math.min(y+dy,p.y))};
      if((p.y-y)*sign<dy*.38){this.shift(0);d.neutral=true;d.position.y=y;}
    }else{
      d.position={x:Math.max(x-dx,Math.min(x+dx,p.x)),y};
      const col=Math.max(-1,Math.min(1,Math.round((p.x-x)/dx)));
      if(Math.abs(p.y-y)>dy*.55&&Math.abs(p.x-(x+col*dx))<dx*.42){
        const gear=(col+1)*2+(p.y<y?1:2);this.shift(gear);d.column=col;d.neutral=false;d.position=this.gearPosition();
      }
    }
  }
}
